import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_PAY_GROUP);

const _pk_name = "id";

const state = {
    data: [],
    entityWiseData: [],
    exits: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};
const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record;
    },
    data: (state) => {
        return state.data;
    }
}

const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data)
    },

    setEditMode: (state, payload) => {
        //console.log("payload---", payload.record);
        state.editMode = payload.editMode;
        state.record = payload.record;
    },
    setExits: (state, payload) => {
        if (payload) {
            state.exits = payload;
        }
        //console.log('fetched exits', state.exits)
    },

    addEmployee: (state, payload) => {
        //console.log('payload data from store', payload)
        state.exits = payload;
        //console.log('exit data', state.exits);
        //console.log('state data', state.data);
        // state.data.push(payload);
    },

    //   updateEmployeeById: (state, payload) => {
    //     for(let i=0; i<state.data.length; i++) {
    //       if(state.data[i][_pk_name] === payload.id) {
    //         state.data.splice(i, 1, payload);
    //       }
    //     }
    //   },

    //   removeEmployeeById: (state, payload) => {
    //     for (let i=0; i<state.data.length; i++){
    //       if (state.data[i][_pk_name] == payload){
    //         state.data.splice(i, 1);
    //       }
    //     }
    //   },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {
  async fetchAll({commit}, payload) {
      //console.log("[state/payroll/payGroup/fetchAll] Calling API...",payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/`);
      // {
      //   params: {
      //     le_id: payload
      //   }
      // }
      commit("setFetching", false);
      //console.log("[state/payroll/payGroup/fetchAll] res: ", res);
      if(res.status == 200) {
        commit("set", res.data.data);
      }
      return res;
    }catch (err){
        //console.log(err);
    }
  },

  async create({commit}, payload) {
      //console.log("[state/payroll/payGroup/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/create] res: ", res);
      if(res.status == 200) {
        commit("addEmployee", payload);
      }
      return res;
    }catch (err){
        //console.log(err);
    }
  },

  async update({commit}, payload) {
      //console.log("[state/payroll/payGroup/update] Updating... Display payload", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.put(`/${payload.id}`, payload);
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/update] res: ", res);
      if(res.status == 200) {
        commit("updateEmployeeById", res.data);
      }
      return res;
    }catch (err){
        //console.log(err);
    }
  },

  async delete({commit}, payload) {
    //console.log("[state/payroll/payGroup/delete] Payload:", payload);
    //console.log("[state/payroll/payGroup/delete] Payload:", `/${payload.id}`);
    try {
      commit("setDeleting", true);
      let res = await axios_instance.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status == 200){
        commit("removeEmployeeById", payload.id);
      }
    }catch (err){
        //console.log(err);

    }
  },
  async changeEditMode({ commit }, payload) {
    // //console.log(
    //   "[state/onboard/designations/changeEditMode] Payload:",
    //   payload
    // );
    try {
      commit("setEditMode", payload);
    } catch(err) {
      //console.log(err)
    }
  }
}

export default {
  namespaced: true,
  state, mutations, actions, getters
}
